import * as types from '../actions/actionTypes'


const pointsReducer = (state = {
    allPoints: [],
    filteredPoints: [],
}, action) => {

    switch(action.type) {
      case types.GET_POINTS_SUCCESS: 

      let tempPoints = []
      let tempFilteredPoints = []
      for (var pointsKey in action.payload) {
        tempPoints.push(action.payload[pointsKey])
        if (!action.payload[pointsKey].hasBeenChecked){
          tempFilteredPoints.push(action.payload[pointsKey])
        }

       }

      state = {
        ...state,
        allPoints: tempPoints,
        filteredPoints: tempFilteredPoints,
      };
      break;
      case types.POINTS_POINT_APPROVAL:
      let tempFilteredPointsForApproval = []
      const approvalSelectedPointsPoints = state.allPoints.map(pointObject =>{
        if (pointObject.nodeName === action.payload) {
          pointObject.approved = true
          pointObject.approvedBy = action.payloadTwo
          pointObject.hasBeenChecked = true
        }
        if (!pointObject.hasBeenChecked){
          tempFilteredPointsForApproval.push(pointObject)
        }
      })

      state = {
        ...state,
        allPoints: approvalSelectedPointsPoints,
        filteredPoints: tempFilteredPointsForApproval,
      };

      break;
      case types.POINTS_POINT_DENY:
        let tempFilteredPointsForDeny= []
        const denySelectedPointsPoints = state.allPoints.map(pointObject =>{
          if (pointObject.nodeName === action.payload) {
            pointObject.approved = false
            pointObject.approvedBy = action.payloadTwo
            pointObject.hasBeenChecked = true
          }
          if (!pointObject.hasBeenChecked){
            tempFilteredPointsForDeny.push(pointObject)
          }
        })

        state = {
          ...state,
          allPoints: denySelectedPointsPoints,
          filteredPoints: tempFilteredPointsForDeny,
        };
      break;
      case types.POINTS_POINT_DELETE:
        const deleteSelectedPointsPoints = state.allPoints
        const deleteFilteredPointsPoints = state.filteredPoints
          
        const resultDelete = deleteSelectedPointsPoints.filter(pointObject => pointObject.nodeName != action.payload);
        const resultFilteredDelete = deleteFilteredPointsPoints.filter(pointObject => pointObject.nodeName != action.payload);
        state = {
          ...state,
          allPoints: resultDelete,
          filteredPoints: resultFilteredDelete,
        };
      break;
      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allPoints: action.payloadTwo ? state.allPoints : [],
        filteredPoints: action.payloadTwo ? state.filteredPoints : []
      };
      break;
      default:
      break;    
    }

    return state;
};


export default pointsReducer;



// WEBPACK FOOTER //
// ./src/reducers/pointsReducer.js